import styled from "styled-components";

const colors = {
  line: "rgba(255,255,255,0.16)",
  text: "#ffffffff",
  bgGlass: "#8b8064",
  hover: "rgba(0,0,0,0.06)", // ușor mai închis la hover peste auriu
};

export const ButtonWrap = styled.button`
  position: fixed;
  left: 14px;
  bottom: 20px;
  z-index: 9999;

  display: inline-flex;
  align-items: center;
  gap: 8px;

  background: ${colors.bgGlass};
  color: ${colors.text};
  border: 1px solid ${colors.line};
  border-radius: 999px;
  padding: 8px 12px;

  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.2px;

  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);
  -webkit-tap-highlight-color: transparent;
  cursor: pointer;

  /* mobil: bulină cu auto-hide; desktop: mereu vizibil (forțăm true din componentă) */
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: translateY(${({ $visible }) => ($visible ? "0" : "6px")});
  pointer-events: ${({ $visible }) => ($visible ? "auto" : "none")};
  transition: opacity 0.25s ease, transform 0.25s ease;

  svg {
    display: block;
    stroke: ${colors.text};
  }

  span {
    white-space: nowrap;
  }

  &:hover {
    background: ${colors.hover};
  }

  /* rămâne vizibil și pe desktop; păstrăm doar mici ajustări la mobil */
  @media (max-width: 768px) {
    bottom: 18px;
    font-size: 14px;
    padding: 8px 12px;
  }
`;
